module.exports = __webpack_public_path__ + "static/media/stepper-collaborate.c6621ebd.svg";